// extracted by mini-css-extract-plugin
export var addButton = "_gx-0";
export var border = "_gx-8";
export var check = "_gx-h";
export var danger = "_gx-6";
export var dropdownContainer = "_gx-1";
export var editModalBody = "_gx-j";
export var footerContainer = "_gx-i";
export var fullWidth = "_gx-a";
export var hide = "_gx-9";
export var icon = "_gx-3";
export var input = "_gx-7";
export var inputFlex = "_gx-b";
export var inputWrapper = "_gx-c";
export var manualFocus = "_gx-5";
export var optionButton = "_gx-4";
export var pillWrapper = "_gx-e";
export var pointer = "_gx-2";
export var showOverflow = "_gx-f";
export var tagsFlex = "_gx-d";
export var xButton = "_gx-g";